import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { v4 as uuid } from 'uuid';

import { getHttpHeadersWithTractId, REQUEST_TIMEOUT_IN_SECONDS } from '../../../common/constants/constants';
import { resourceServerUrl } from '../../../common/constants/server-settings';

@Injectable({
    providedIn: 'root'
})
export class HeaderService {
    constructor(private http: HttpClient) {}

    getUserProfileInfo(): Observable<HttpResponse<any>> {
        return this.http.get(`${resourceServerUrl}/v1/user/profile/info`, {
            headers: getHttpHeadersWithTractId(),

            observe: 'response'
        });
    }

    getNotification(offset: number = 0): Observable<any> {
        let URL = `${resourceServerUrl}/api/v2/banks/010/notifications/in-app/?offset=${offset}&limit=1000`;
        let headers = new HttpHeaders().set('Request-Id', uuid()).set('Request-Time', new Date().toISOString()).set('Request-Timeout-In-Seconds', REQUEST_TIMEOUT_IN_SECONDS);
        return this.http.get(URL, {
            headers: headers,
            observe: 'response'
        });
    }

    checkForNewNotification(): Observable<any> {
        let URL = `${resourceServerUrl}/api/v2/banks/010/notifications/in-app/check`;
        let headers = new HttpHeaders().set('Request-Id', uuid()).set('Request-Time', new Date().toISOString()).set('Request-Timeout-In-Seconds', REQUEST_TIMEOUT_IN_SECONDS);
        return this.http.get(URL, {
            headers: headers,
            observe: 'response'
        });
    }

    //getEkpayMetadata(): Observable<HttpResponse<any>> {

    //  return this.http.get(`${resourceServerUrl}/v1/banks/${BANK_ID}/bill/metadata`, {
    //    headers: getHttpHeaders(),
    //    observe: 'response'
    //  });
    //}
}
